export default "__VITE_ASSET__BxbC$VhF__"